// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__2b8Tb","left":"InfoRow_left__1GmAo"};